import { useWebRTC } from "../../../contexts/WebRTCContext";

const LayoutIcon = ({ camsIds, onClick }) => {

  return (
    <div onClick={onClick} className="h-full flex w-16 justify-center gap-1 text-sm select-none cursor-pointer hover:scale-110">
      <div className="w-1/2 h-full bg-perception-black-500 rounded flex justify-center items-center">{camsIds[0]}</div>
      <div className="w-1/2 h-1/2 flex flex-col gap-1">
        <div className="bg-perception-black-700 rounded flex justify-center items-center">{camsIds[1]}</div>
        <div className="bg-perception-black-700 rounded flex justify-center items-center">{camsIds[2]}</div>
      </div>
    </div>
  );
};

export const CamerasLayoutShortcuts = () => {
  const { cams, setLayoutPreset } = useWebRTC();

  const applyPreset = (presetIdx) => {
    if (!Array.isArray(cams) || cams.length !== 3) return;
    setLayoutPreset(presetIdx);
  };

  return (
    <div className="h-full flex gap-4">
      <LayoutIcon camsIds={[1,2,3]} onClick={() => applyPreset([0, 1, 2])}/>
      <LayoutIcon camsIds={[2,1,3]} onClick={() => applyPreset([1, 0, 2])}/>
      <LayoutIcon camsIds={[3,1,2]} onClick={() => applyPreset([2, 0, 1])}/>
    </div>
  );
};